import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Batch, TemplateType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batch: Batch;
}

export const useSyncBatchWithCustoms = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batch }: HookProps) => {
      if (batch.templateType === TemplateType.HIGH_VALUE_H1) {
        // temp: don't wait for the external notifications to be pulled
        // issue with xcomm FTP server
        Promise.allSettled([
          request({
            path: `idms/${batch._id}/customs-sync`,
            method: 'POST',
            authenticate: true,
          }),
        ]);
      } else {
        await request({
          path: `idms/${batch._id}/customs-sync`,
          method: 'POST',
          authenticate: true,
        });
      }

      await request({
        path: `batches/${batch.counter}/recount-statistics`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Batch is added to syncing queue.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error syncing the batch!');
    },
  });
};
